export default __webpack_public_path__ + "static/media/ecology-3.15ba69a1.png";